import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logo from '../../Logo';
import Wizard from '../../Wizard/Wizard';
import PhoneStep from './Steps/PhoneStep';
import SmsStep from './Steps/SmsStep';
import DealDetails from './Steps/DealDetails';
import UserDetails from './Steps/UserDetails';
import ServicesDescription from './Steps/ServicesDescription';
import PhotoIdUpload from './Steps/PhotoIdUpload';
import Contracts from './Steps/Contracts';
import Summary from './Steps/Summary';
import { Map } from 'immutable';
import { updateOnboardingWizardProgress, getCurrentPage, getSummary } from '../../../reducers/currentProgressOnboardingWizard';
import { logginRequest } from '../../../reducers/auth';
import { getLanguage } from '../../../reducers/i18n';
import BankDetails from './Steps/BankDetails';
import BankInstructions from './Steps/BankInstructions/BankInstructions';
import * as tracking from '../../../tracking/tracking';
import P from 'prop-types';


const noop = () => {};
class OnBoardingWizard extends Component {
  constructor(props) {
    super(props);
    const { currentPage, summary } = this.props;
    this.page = currentPage || 1;
    this.summary = summary || new Map();
    tracking.addMemberType('living');
  }



  render() {
    const { updateOnboardingWizardProgress, language } = this.props;
    return (
      <div className="onboarding-wizard">
        <div className="onboarding-wizard__wrapper">
          <Logo text="Tel aviv" />
          <Wizard
            initialStep={this.page}
            summary={this.summary}
            onComplete={noop}
            onPrematureExit={updateOnboardingWizardProgress}
            containerClassName="onboarding-wizard__component"
            arrowClassName={`onboarding-wizard__arrow ${language.startsWith('he') ? 'onboarding-wizard__arrow--rtl' : ''}`}
            language={language}
          >
            <PhoneStep />
            <SmsStep />
            <DealDetails />
            <ServicesDescription />
            <UserDetails />
            <Contracts />
            <BankDetails />
            <BankInstructions />
            <PhotoIdUpload />
            <Summary />
          </Wizard>
        </div>
      </div>
    );
  }
}

OnBoardingWizard.propTypes = {
  language: P.string,
  updateOnboardingWizardProgress: P.func,
  currentPage: P.number,
  summary: P.object
};

const mapStateToProps = state => ({
  currentPage: getCurrentPage(state),
  summary: getSummary(state),
  language: getLanguage(state)
});


const mapDispatchToProps = dispatch => ({
  updateOnboardingWizardProgress,
  login: (token) => dispatch(logginRequest(token))
})


export default connect(mapStateToProps, mapDispatchToProps)(OnBoardingWizard);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/OnBoardingWizard.js